import { isTrackingDataMatch } from './isTrackingDataMatch';
import { subscribe, unsubscribe } from '../message-bus';
import { MB_TRACK_COMPLETED } from '../consts';
export const whenTrackCompleted = ({ resolve, timeout, trackData }) => {
    const token = subscribe({
        topic: MB_TRACK_COMPLETED,
        callback: ({ data: trackCompletedData }) => {
            // compare tracking events payload to determine if the adapter managed to finish its work.
            if (isTrackingDataMatch({ trackData, trackCompletedData })) {
                clearTimeout(timeout);
                resolve();
            }
            unsubscribe(token);
        },
    });
};
